﻿export const cssPrefix = 'fe';
export const toolIcon= {
    textarea: '📝', text: '🔤', combobox: '🔽', checkbox: '☑️', radio: '🔘', button: '🔲', signature: '✍️'
}
export const dpr = window.devicePixelRatio || 1;
export default {
    cssPrefix,
    dpr,
    toolIcon
};